import { useQuery } from '@tanstack/react-query';
import { WsContentApi } from 'api/ApiHelper';
import { studioQueryKey } from 'queries/studio/queryKey';

export const useGetWsContentsQuery = () =>
  useQuery({ queryKey: studioQueryKey.contents, queryFn: () => WsContentApi.getWsContents() });
